import { IconPropTypes } from '@/legacy/types';

const ArrowRight = (props: IconPropTypes) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={props.width || 24}
			height={props.height || 24}
			fill='none'
			viewBox='0 0 24 24'
			{...props}
		>
			<path
				fill={props.color || 'currentColor'}
				d='M18.417 12.75H5.583a.583.583 0 0 1 0-1.167h12.834a.583.583 0 0 1 0 1.167Z'
			/>
			<path
				fill={props.color || 'currentColor'}
				d='M12.193 7.35a.584.584 0 0 1 .78-.867l5.834 5.25a.583.583 0 0 1 0 .867l-5.833 5.25-.047.038a.584.584 0 0 1-.776-.863l.042-.042 5.35-4.816-5.35-4.817Z'
			/>
		</svg>
	);
};
export default ArrowRight;
